import { padNumber } from '../../utils/misc';

class TextDOB {
	constructor() {
		this.state = {
			day: '',
			month: '',
			year: ''
		}
		this.mapToDate()
	}

	mapToDate() {
		const dobWrapper = document.querySelectorAll('.lta-text-dob');

		if (dobWrapper !== null) {
			dobWrapper.forEach((wrapper) => {
				const fullDate = wrapper.querySelector('.full-date');
				const dateInputs = wrapper.querySelectorAll('.lta-text-input');

				if (fullDate.value !== '') {
					const existingDate = new Date(fullDate.value);
					if (!Number.isNaN(existingDate.getTime())) {
						this.state.year = existingDate.getFullYear();
						this.state.month = padNumber(existingDate.getMonth() + 1);
						this.state.day = padNumber(existingDate.getDate());

						dateInputs.forEach((input) => {
							if (input.classList.contains('is-day')) {
								input.value = this.state.day
							}
							if (input.classList.contains('is-month')) {
								input.value = this.state.month
							}
							if (input.classList.contains('is-year')) {
								input.value = this.state.year
							}
						})
					}
				}

				dateInputs.forEach((input) => {
					input.addEventListener('blur', (event) => {

						const { value } = event.target;
						if (input.classList.contains('is-day')) {
							this.state.day = value;
						}
						if (input.classList.contains('is-month')) {
							this.state.month = value;
						}
						if (input.classList.contains('is-year')) {
							this.state.year = value;
						}

						const { day, month, year } = this.state;
						if (year !== '' && month !== '' && day !== '') {
							const enteredDate = new Date(`${padNumber(month)}/${padNumber(day)}/${year}`);
							if (!Number.isNaN(enteredDate.getTime())) {
								fullDate.value = `${enteredDate.getFullYear()}-${padNumber(enteredDate.getMonth() + 1)}-${padNumber(enteredDate.getDate())}`;
							}
						}
					});
					input.addEventListener('input', () => {
						// numerical only
						const cleanValue = input.value.replace(new RegExp(/[^\d]/,'ig'), '');
						input.value = cleanValue;
					});
				})
			})
		}
	}
}

const globalTextDOB = new TextDOB();

export default globalTextDOB;
